"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Massmapper
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1678874375922
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAPIApi = exports.UserAPIApiFactory = exports.UserAPIApiFp = exports.UserAPIApiAxiosParamCreator = exports.StatAPIApi = exports.StatAPIApiFactory = exports.StatAPIApiFp = exports.StatAPIApiAxiosParamCreator = exports.Search4facesAPIApi = exports.Search4facesAPIApiFactory = exports.Search4facesAPIApiFp = exports.Search4facesAPIApiAxiosParamCreator = exports.ProfileAPIApi = exports.ProfileAPIApiFactory = exports.ProfileAPIApiFp = exports.ProfileAPIApiAxiosParamCreator = exports.JobAPIApi = exports.JobAPIApiFactory = exports.JobAPIApiFp = exports.JobAPIApiAxiosParamCreator = exports.AuthControllerApi = exports.AuthControllerApiFactory = exports.AuthControllerApiFp = exports.AuthControllerApiAxiosParamCreator = exports.ApiToGetImageFileApi = exports.ApiToGetImageFileApiFactory = exports.ApiToGetImageFileApiFp = exports.ApiToGetImageFileApiAxiosParamCreator = exports.ApiToGetAuditApi = exports.ApiToGetAuditApiFactory = exports.ApiToGetAuditApiFp = exports.ApiToGetAuditApiAxiosParamCreator = exports.ApiToCheckHealthStatusOfAppApi = exports.ApiToCheckHealthStatusOfAppApiFactory = exports.ApiToCheckHealthStatusOfAppApiFp = exports.ApiToCheckHealthStatusOfAppApiAxiosParamCreator = exports.ZaloSourceEnum = exports.WhatsappSourceEnum = exports.WechatSourceEnum = exports.VkontakteSourceEnum = exports.ViberSourceEnum = exports.UserUpdateDTORolesEnum = exports.UserInfoDTORolesEnum = exports.UserDTORolesEnum = exports.TelegramSourceEnum = exports.TcSourceEnum = exports.TamtamSourceEnum = exports.TamtamStatusEnum = exports.TamtamOptionsEnum = exports.TamtamTypeEnum = exports.TamtamGenderEnum = exports.SyncmeSourceEnum = exports.SocialNetworkWrapperSocialNetworkEnum = exports.SkypeSourceEnum = exports.ProfileWrapperLmSourceEnum = exports.ProfileInfoSourceEnum = exports.ProfileDtoSourceEnum = exports.ProfileSourceEnum = exports.PhoneDtoSourcesEnum = exports.NameTypeEnum = exports.MeSourceEnum = exports.LineSourceEnum = exports.JobDtoStatusEnum = exports.JobDtoTypeEnum = exports.ImoSourceEnum = exports.HiyaSourceEnum = exports.GetcontactSourceEnum = exports.EyeconSourceEnum = exports.DrupeSourceEnum = exports.CallappSourceEnum = exports.AuditSearchFilterActionTypeEnum = exports.AuditActionDTOActionTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AuditActionDTOActionTypeEnum;
(function (AuditActionDTOActionTypeEnum) {
    AuditActionDTOActionTypeEnum["LOGIN"] = "LOGIN";
    AuditActionDTOActionTypeEnum["LOGOUT"] = "LOGOUT";
    AuditActionDTOActionTypeEnum["CREATEJOB"] = "CREATE_JOB";
    AuditActionDTOActionTypeEnum["CREATERANGEJOB"] = "CREATE_RANGE_JOB";
    AuditActionDTOActionTypeEnum["JOB"] = "JOB";
    AuditActionDTOActionTypeEnum["PING"] = "PING";
    AuditActionDTOActionTypeEnum["IMAGE"] = "IMAGE";
    AuditActionDTOActionTypeEnum["IMAGECLEARSTORAGE"] = "IMAGE_CLEAR_STORAGE";
    AuditActionDTOActionTypeEnum["AUDIT"] = "AUDIT";
    AuditActionDTOActionTypeEnum["USER"] = "USER";
    AuditActionDTOActionTypeEnum["PROFILE"] = "PROFILE";
    AuditActionDTOActionTypeEnum["HEALTHSTATUS"] = "HEALTH_STATUS";
    AuditActionDTOActionTypeEnum["DELETE"] = "DELETE";
    AuditActionDTOActionTypeEnum["SEARCH4FACES"] = "SEARCH_4_FACES";
})(AuditActionDTOActionTypeEnum = exports.AuditActionDTOActionTypeEnum || (exports.AuditActionDTOActionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AuditSearchFilterActionTypeEnum;
(function (AuditSearchFilterActionTypeEnum) {
    AuditSearchFilterActionTypeEnum["LOGIN"] = "LOGIN";
    AuditSearchFilterActionTypeEnum["LOGOUT"] = "LOGOUT";
    AuditSearchFilterActionTypeEnum["CREATEJOB"] = "CREATE_JOB";
    AuditSearchFilterActionTypeEnum["CREATERANGEJOB"] = "CREATE_RANGE_JOB";
    AuditSearchFilterActionTypeEnum["JOB"] = "JOB";
    AuditSearchFilterActionTypeEnum["PING"] = "PING";
    AuditSearchFilterActionTypeEnum["IMAGE"] = "IMAGE";
    AuditSearchFilterActionTypeEnum["IMAGECLEARSTORAGE"] = "IMAGE_CLEAR_STORAGE";
    AuditSearchFilterActionTypeEnum["AUDIT"] = "AUDIT";
    AuditSearchFilterActionTypeEnum["USER"] = "USER";
    AuditSearchFilterActionTypeEnum["PROFILE"] = "PROFILE";
    AuditSearchFilterActionTypeEnum["HEALTHSTATUS"] = "HEALTH_STATUS";
    AuditSearchFilterActionTypeEnum["DELETE"] = "DELETE";
    AuditSearchFilterActionTypeEnum["SEARCH4FACES"] = "SEARCH_4_FACES";
})(AuditSearchFilterActionTypeEnum = exports.AuditSearchFilterActionTypeEnum || (exports.AuditSearchFilterActionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CallappSourceEnum;
(function (CallappSourceEnum) {
    CallappSourceEnum["TC"] = "TC";
    CallappSourceEnum["ME"] = "ME";
    CallappSourceEnum["WHATSAPP"] = "WHATSAPP";
    CallappSourceEnum["SYNCME"] = "SYNCME";
    CallappSourceEnum["VIBER"] = "VIBER";
    CallappSourceEnum["LINE"] = "LINE";
    CallappSourceEnum["WECHAT"] = "WECHAT";
    CallappSourceEnum["IMO"] = "IMO";
    CallappSourceEnum["GETCONTACT"] = "GETCONTACT";
    CallappSourceEnum["TELEGRAM"] = "TELEGRAM";
    CallappSourceEnum["SKYPE"] = "SKYPE";
    CallappSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    CallappSourceEnum["EYECON"] = "EYECON";
    CallappSourceEnum["CALLAPP"] = "CALLAPP";
    CallappSourceEnum["TAMTAM"] = "TAMTAM";
    CallappSourceEnum["ZALO"] = "ZALO";
    CallappSourceEnum["DRUPE"] = "DRUPE";
    CallappSourceEnum["HIYA"] = "HIYA";
    CallappSourceEnum["DEEPWEB"] = "DEEPWEB";
})(CallappSourceEnum = exports.CallappSourceEnum || (exports.CallappSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DrupeSourceEnum;
(function (DrupeSourceEnum) {
    DrupeSourceEnum["TC"] = "TC";
    DrupeSourceEnum["ME"] = "ME";
    DrupeSourceEnum["WHATSAPP"] = "WHATSAPP";
    DrupeSourceEnum["SYNCME"] = "SYNCME";
    DrupeSourceEnum["VIBER"] = "VIBER";
    DrupeSourceEnum["LINE"] = "LINE";
    DrupeSourceEnum["WECHAT"] = "WECHAT";
    DrupeSourceEnum["IMO"] = "IMO";
    DrupeSourceEnum["GETCONTACT"] = "GETCONTACT";
    DrupeSourceEnum["TELEGRAM"] = "TELEGRAM";
    DrupeSourceEnum["SKYPE"] = "SKYPE";
    DrupeSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    DrupeSourceEnum["EYECON"] = "EYECON";
    DrupeSourceEnum["CALLAPP"] = "CALLAPP";
    DrupeSourceEnum["TAMTAM"] = "TAMTAM";
    DrupeSourceEnum["ZALO"] = "ZALO";
    DrupeSourceEnum["DRUPE"] = "DRUPE";
    DrupeSourceEnum["HIYA"] = "HIYA";
    DrupeSourceEnum["DEEPWEB"] = "DEEPWEB";
})(DrupeSourceEnum = exports.DrupeSourceEnum || (exports.DrupeSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var EyeconSourceEnum;
(function (EyeconSourceEnum) {
    EyeconSourceEnum["TC"] = "TC";
    EyeconSourceEnum["ME"] = "ME";
    EyeconSourceEnum["WHATSAPP"] = "WHATSAPP";
    EyeconSourceEnum["SYNCME"] = "SYNCME";
    EyeconSourceEnum["VIBER"] = "VIBER";
    EyeconSourceEnum["LINE"] = "LINE";
    EyeconSourceEnum["WECHAT"] = "WECHAT";
    EyeconSourceEnum["IMO"] = "IMO";
    EyeconSourceEnum["GETCONTACT"] = "GETCONTACT";
    EyeconSourceEnum["TELEGRAM"] = "TELEGRAM";
    EyeconSourceEnum["SKYPE"] = "SKYPE";
    EyeconSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    EyeconSourceEnum["EYECON"] = "EYECON";
    EyeconSourceEnum["CALLAPP"] = "CALLAPP";
    EyeconSourceEnum["TAMTAM"] = "TAMTAM";
    EyeconSourceEnum["ZALO"] = "ZALO";
    EyeconSourceEnum["DRUPE"] = "DRUPE";
    EyeconSourceEnum["HIYA"] = "HIYA";
    EyeconSourceEnum["DEEPWEB"] = "DEEPWEB";
})(EyeconSourceEnum = exports.EyeconSourceEnum || (exports.EyeconSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetcontactSourceEnum;
(function (GetcontactSourceEnum) {
    GetcontactSourceEnum["TC"] = "TC";
    GetcontactSourceEnum["ME"] = "ME";
    GetcontactSourceEnum["WHATSAPP"] = "WHATSAPP";
    GetcontactSourceEnum["SYNCME"] = "SYNCME";
    GetcontactSourceEnum["VIBER"] = "VIBER";
    GetcontactSourceEnum["LINE"] = "LINE";
    GetcontactSourceEnum["WECHAT"] = "WECHAT";
    GetcontactSourceEnum["IMO"] = "IMO";
    GetcontactSourceEnum["GETCONTACT"] = "GETCONTACT";
    GetcontactSourceEnum["TELEGRAM"] = "TELEGRAM";
    GetcontactSourceEnum["SKYPE"] = "SKYPE";
    GetcontactSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    GetcontactSourceEnum["EYECON"] = "EYECON";
    GetcontactSourceEnum["CALLAPP"] = "CALLAPP";
    GetcontactSourceEnum["TAMTAM"] = "TAMTAM";
    GetcontactSourceEnum["ZALO"] = "ZALO";
    GetcontactSourceEnum["DRUPE"] = "DRUPE";
    GetcontactSourceEnum["HIYA"] = "HIYA";
    GetcontactSourceEnum["DEEPWEB"] = "DEEPWEB";
})(GetcontactSourceEnum = exports.GetcontactSourceEnum || (exports.GetcontactSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var HiyaSourceEnum;
(function (HiyaSourceEnum) {
    HiyaSourceEnum["TC"] = "TC";
    HiyaSourceEnum["ME"] = "ME";
    HiyaSourceEnum["WHATSAPP"] = "WHATSAPP";
    HiyaSourceEnum["SYNCME"] = "SYNCME";
    HiyaSourceEnum["VIBER"] = "VIBER";
    HiyaSourceEnum["LINE"] = "LINE";
    HiyaSourceEnum["WECHAT"] = "WECHAT";
    HiyaSourceEnum["IMO"] = "IMO";
    HiyaSourceEnum["GETCONTACT"] = "GETCONTACT";
    HiyaSourceEnum["TELEGRAM"] = "TELEGRAM";
    HiyaSourceEnum["SKYPE"] = "SKYPE";
    HiyaSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    HiyaSourceEnum["EYECON"] = "EYECON";
    HiyaSourceEnum["CALLAPP"] = "CALLAPP";
    HiyaSourceEnum["TAMTAM"] = "TAMTAM";
    HiyaSourceEnum["ZALO"] = "ZALO";
    HiyaSourceEnum["DRUPE"] = "DRUPE";
    HiyaSourceEnum["HIYA"] = "HIYA";
    HiyaSourceEnum["DEEPWEB"] = "DEEPWEB";
})(HiyaSourceEnum = exports.HiyaSourceEnum || (exports.HiyaSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ImoSourceEnum;
(function (ImoSourceEnum) {
    ImoSourceEnum["TC"] = "TC";
    ImoSourceEnum["ME"] = "ME";
    ImoSourceEnum["WHATSAPP"] = "WHATSAPP";
    ImoSourceEnum["SYNCME"] = "SYNCME";
    ImoSourceEnum["VIBER"] = "VIBER";
    ImoSourceEnum["LINE"] = "LINE";
    ImoSourceEnum["WECHAT"] = "WECHAT";
    ImoSourceEnum["IMO"] = "IMO";
    ImoSourceEnum["GETCONTACT"] = "GETCONTACT";
    ImoSourceEnum["TELEGRAM"] = "TELEGRAM";
    ImoSourceEnum["SKYPE"] = "SKYPE";
    ImoSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ImoSourceEnum["EYECON"] = "EYECON";
    ImoSourceEnum["CALLAPP"] = "CALLAPP";
    ImoSourceEnum["TAMTAM"] = "TAMTAM";
    ImoSourceEnum["ZALO"] = "ZALO";
    ImoSourceEnum["DRUPE"] = "DRUPE";
    ImoSourceEnum["HIYA"] = "HIYA";
    ImoSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ImoSourceEnum = exports.ImoSourceEnum || (exports.ImoSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var JobDtoTypeEnum;
(function (JobDtoTypeEnum) {
    JobDtoTypeEnum["MAIN"] = "MAIN";
    JobDtoTypeEnum["ADDITIONAL"] = "ADDITIONAL";
})(JobDtoTypeEnum = exports.JobDtoTypeEnum || (exports.JobDtoTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var JobDtoStatusEnum;
(function (JobDtoStatusEnum) {
    JobDtoStatusEnum["INPROGRESS"] = "IN_PROGRESS";
    JobDtoStatusEnum["PAUSED"] = "PAUSED";
    JobDtoStatusEnum["SCHEDULED"] = "SCHEDULED";
    JobDtoStatusEnum["DONE"] = "DONE";
    JobDtoStatusEnum["CANCELED"] = "CANCELED";
})(JobDtoStatusEnum = exports.JobDtoStatusEnum || (exports.JobDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LineSourceEnum;
(function (LineSourceEnum) {
    LineSourceEnum["TC"] = "TC";
    LineSourceEnum["ME"] = "ME";
    LineSourceEnum["WHATSAPP"] = "WHATSAPP";
    LineSourceEnum["SYNCME"] = "SYNCME";
    LineSourceEnum["VIBER"] = "VIBER";
    LineSourceEnum["LINE"] = "LINE";
    LineSourceEnum["WECHAT"] = "WECHAT";
    LineSourceEnum["IMO"] = "IMO";
    LineSourceEnum["GETCONTACT"] = "GETCONTACT";
    LineSourceEnum["TELEGRAM"] = "TELEGRAM";
    LineSourceEnum["SKYPE"] = "SKYPE";
    LineSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    LineSourceEnum["EYECON"] = "EYECON";
    LineSourceEnum["CALLAPP"] = "CALLAPP";
    LineSourceEnum["TAMTAM"] = "TAMTAM";
    LineSourceEnum["ZALO"] = "ZALO";
    LineSourceEnum["DRUPE"] = "DRUPE";
    LineSourceEnum["HIYA"] = "HIYA";
    LineSourceEnum["DEEPWEB"] = "DEEPWEB";
})(LineSourceEnum = exports.LineSourceEnum || (exports.LineSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MeSourceEnum;
(function (MeSourceEnum) {
    MeSourceEnum["TC"] = "TC";
    MeSourceEnum["ME"] = "ME";
    MeSourceEnum["WHATSAPP"] = "WHATSAPP";
    MeSourceEnum["SYNCME"] = "SYNCME";
    MeSourceEnum["VIBER"] = "VIBER";
    MeSourceEnum["LINE"] = "LINE";
    MeSourceEnum["WECHAT"] = "WECHAT";
    MeSourceEnum["IMO"] = "IMO";
    MeSourceEnum["GETCONTACT"] = "GETCONTACT";
    MeSourceEnum["TELEGRAM"] = "TELEGRAM";
    MeSourceEnum["SKYPE"] = "SKYPE";
    MeSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    MeSourceEnum["EYECON"] = "EYECON";
    MeSourceEnum["CALLAPP"] = "CALLAPP";
    MeSourceEnum["TAMTAM"] = "TAMTAM";
    MeSourceEnum["ZALO"] = "ZALO";
    MeSourceEnum["DRUPE"] = "DRUPE";
    MeSourceEnum["HIYA"] = "HIYA";
    MeSourceEnum["DEEPWEB"] = "DEEPWEB";
})(MeSourceEnum = exports.MeSourceEnum || (exports.MeSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var NameTypeEnum;
(function (NameTypeEnum) {
    NameTypeEnum["UNKNOWN"] = "UNKNOWN";
    NameTypeEnum["OK"] = "OK";
    NameTypeEnum["TT"] = "TT";
    NameTypeEnum["CUSTOM"] = "CUSTOM";
    NameTypeEnum["DEVICE"] = "DEVICE";
    NameTypeEnum["CONSTRUCTOR"] = "CONSTRUCTOR";
})(NameTypeEnum = exports.NameTypeEnum || (exports.NameTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PhoneDtoSourcesEnum;
(function (PhoneDtoSourcesEnum) {
    PhoneDtoSourcesEnum["TC"] = "TC";
    PhoneDtoSourcesEnum["ME"] = "ME";
    PhoneDtoSourcesEnum["WHATSAPP"] = "WHATSAPP";
    PhoneDtoSourcesEnum["SYNCME"] = "SYNCME";
    PhoneDtoSourcesEnum["VIBER"] = "VIBER";
    PhoneDtoSourcesEnum["LINE"] = "LINE";
    PhoneDtoSourcesEnum["WECHAT"] = "WECHAT";
    PhoneDtoSourcesEnum["IMO"] = "IMO";
    PhoneDtoSourcesEnum["GETCONTACT"] = "GETCONTACT";
    PhoneDtoSourcesEnum["TELEGRAM"] = "TELEGRAM";
    PhoneDtoSourcesEnum["SKYPE"] = "SKYPE";
    PhoneDtoSourcesEnum["VKONTAKTE"] = "VKONTAKTE";
    PhoneDtoSourcesEnum["EYECON"] = "EYECON";
    PhoneDtoSourcesEnum["CALLAPP"] = "CALLAPP";
    PhoneDtoSourcesEnum["TAMTAM"] = "TAMTAM";
    PhoneDtoSourcesEnum["ZALO"] = "ZALO";
    PhoneDtoSourcesEnum["DRUPE"] = "DRUPE";
    PhoneDtoSourcesEnum["HIYA"] = "HIYA";
    PhoneDtoSourcesEnum["DEEPWEB"] = "DEEPWEB";
})(PhoneDtoSourcesEnum = exports.PhoneDtoSourcesEnum || (exports.PhoneDtoSourcesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProfileSourceEnum;
(function (ProfileSourceEnum) {
    ProfileSourceEnum["TC"] = "TC";
    ProfileSourceEnum["ME"] = "ME";
    ProfileSourceEnum["WHATSAPP"] = "WHATSAPP";
    ProfileSourceEnum["SYNCME"] = "SYNCME";
    ProfileSourceEnum["VIBER"] = "VIBER";
    ProfileSourceEnum["LINE"] = "LINE";
    ProfileSourceEnum["WECHAT"] = "WECHAT";
    ProfileSourceEnum["IMO"] = "IMO";
    ProfileSourceEnum["GETCONTACT"] = "GETCONTACT";
    ProfileSourceEnum["TELEGRAM"] = "TELEGRAM";
    ProfileSourceEnum["SKYPE"] = "SKYPE";
    ProfileSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ProfileSourceEnum["EYECON"] = "EYECON";
    ProfileSourceEnum["CALLAPP"] = "CALLAPP";
    ProfileSourceEnum["TAMTAM"] = "TAMTAM";
    ProfileSourceEnum["ZALO"] = "ZALO";
    ProfileSourceEnum["DRUPE"] = "DRUPE";
    ProfileSourceEnum["HIYA"] = "HIYA";
    ProfileSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ProfileSourceEnum = exports.ProfileSourceEnum || (exports.ProfileSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProfileDtoSourceEnum;
(function (ProfileDtoSourceEnum) {
    ProfileDtoSourceEnum["TC"] = "TC";
    ProfileDtoSourceEnum["ME"] = "ME";
    ProfileDtoSourceEnum["WHATSAPP"] = "WHATSAPP";
    ProfileDtoSourceEnum["SYNCME"] = "SYNCME";
    ProfileDtoSourceEnum["VIBER"] = "VIBER";
    ProfileDtoSourceEnum["LINE"] = "LINE";
    ProfileDtoSourceEnum["WECHAT"] = "WECHAT";
    ProfileDtoSourceEnum["IMO"] = "IMO";
    ProfileDtoSourceEnum["GETCONTACT"] = "GETCONTACT";
    ProfileDtoSourceEnum["TELEGRAM"] = "TELEGRAM";
    ProfileDtoSourceEnum["SKYPE"] = "SKYPE";
    ProfileDtoSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ProfileDtoSourceEnum["EYECON"] = "EYECON";
    ProfileDtoSourceEnum["CALLAPP"] = "CALLAPP";
    ProfileDtoSourceEnum["TAMTAM"] = "TAMTAM";
    ProfileDtoSourceEnum["ZALO"] = "ZALO";
    ProfileDtoSourceEnum["DRUPE"] = "DRUPE";
    ProfileDtoSourceEnum["HIYA"] = "HIYA";
    ProfileDtoSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ProfileDtoSourceEnum = exports.ProfileDtoSourceEnum || (exports.ProfileDtoSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProfileInfoSourceEnum;
(function (ProfileInfoSourceEnum) {
    ProfileInfoSourceEnum["TC"] = "TC";
    ProfileInfoSourceEnum["ME"] = "ME";
    ProfileInfoSourceEnum["WHATSAPP"] = "WHATSAPP";
    ProfileInfoSourceEnum["SYNCME"] = "SYNCME";
    ProfileInfoSourceEnum["VIBER"] = "VIBER";
    ProfileInfoSourceEnum["LINE"] = "LINE";
    ProfileInfoSourceEnum["WECHAT"] = "WECHAT";
    ProfileInfoSourceEnum["IMO"] = "IMO";
    ProfileInfoSourceEnum["GETCONTACT"] = "GETCONTACT";
    ProfileInfoSourceEnum["TELEGRAM"] = "TELEGRAM";
    ProfileInfoSourceEnum["SKYPE"] = "SKYPE";
    ProfileInfoSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ProfileInfoSourceEnum["EYECON"] = "EYECON";
    ProfileInfoSourceEnum["CALLAPP"] = "CALLAPP";
    ProfileInfoSourceEnum["TAMTAM"] = "TAMTAM";
    ProfileInfoSourceEnum["ZALO"] = "ZALO";
    ProfileInfoSourceEnum["DRUPE"] = "DRUPE";
    ProfileInfoSourceEnum["HIYA"] = "HIYA";
    ProfileInfoSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ProfileInfoSourceEnum = exports.ProfileInfoSourceEnum || (exports.ProfileInfoSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProfileWrapperLmSourceEnum;
(function (ProfileWrapperLmSourceEnum) {
    ProfileWrapperLmSourceEnum["TC"] = "TC";
    ProfileWrapperLmSourceEnum["ME"] = "ME";
    ProfileWrapperLmSourceEnum["WHATSAPP"] = "WHATSAPP";
    ProfileWrapperLmSourceEnum["SYNCME"] = "SYNCME";
    ProfileWrapperLmSourceEnum["VIBER"] = "VIBER";
    ProfileWrapperLmSourceEnum["LINE"] = "LINE";
    ProfileWrapperLmSourceEnum["WECHAT"] = "WECHAT";
    ProfileWrapperLmSourceEnum["IMO"] = "IMO";
    ProfileWrapperLmSourceEnum["GETCONTACT"] = "GETCONTACT";
    ProfileWrapperLmSourceEnum["TELEGRAM"] = "TELEGRAM";
    ProfileWrapperLmSourceEnum["SKYPE"] = "SKYPE";
    ProfileWrapperLmSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ProfileWrapperLmSourceEnum["EYECON"] = "EYECON";
    ProfileWrapperLmSourceEnum["CALLAPP"] = "CALLAPP";
    ProfileWrapperLmSourceEnum["TAMTAM"] = "TAMTAM";
    ProfileWrapperLmSourceEnum["ZALO"] = "ZALO";
    ProfileWrapperLmSourceEnum["DRUPE"] = "DRUPE";
    ProfileWrapperLmSourceEnum["HIYA"] = "HIYA";
    ProfileWrapperLmSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ProfileWrapperLmSourceEnum = exports.ProfileWrapperLmSourceEnum || (exports.ProfileWrapperLmSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SkypeSourceEnum;
(function (SkypeSourceEnum) {
    SkypeSourceEnum["TC"] = "TC";
    SkypeSourceEnum["ME"] = "ME";
    SkypeSourceEnum["WHATSAPP"] = "WHATSAPP";
    SkypeSourceEnum["SYNCME"] = "SYNCME";
    SkypeSourceEnum["VIBER"] = "VIBER";
    SkypeSourceEnum["LINE"] = "LINE";
    SkypeSourceEnum["WECHAT"] = "WECHAT";
    SkypeSourceEnum["IMO"] = "IMO";
    SkypeSourceEnum["GETCONTACT"] = "GETCONTACT";
    SkypeSourceEnum["TELEGRAM"] = "TELEGRAM";
    SkypeSourceEnum["SKYPE"] = "SKYPE";
    SkypeSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    SkypeSourceEnum["EYECON"] = "EYECON";
    SkypeSourceEnum["CALLAPP"] = "CALLAPP";
    SkypeSourceEnum["TAMTAM"] = "TAMTAM";
    SkypeSourceEnum["ZALO"] = "ZALO";
    SkypeSourceEnum["DRUPE"] = "DRUPE";
    SkypeSourceEnum["HIYA"] = "HIYA";
    SkypeSourceEnum["DEEPWEB"] = "DEEPWEB";
})(SkypeSourceEnum = exports.SkypeSourceEnum || (exports.SkypeSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SocialNetworkWrapperSocialNetworkEnum;
(function (SocialNetworkWrapperSocialNetworkEnum) {
    SocialNetworkWrapperSocialNetworkEnum["FB"] = "FB";
    SocialNetworkWrapperSocialNetworkEnum["FACEBOOK"] = "FACEBOOK";
    SocialNetworkWrapperSocialNetworkEnum["ODNOKLASSNIKI"] = "ODNOKLASSNIKI";
    SocialNetworkWrapperSocialNetworkEnum["VKONTAKTE"] = "VKONTAKTE";
    SocialNetworkWrapperSocialNetworkEnum["LINKEDIN"] = "LINKEDIN";
    SocialNetworkWrapperSocialNetworkEnum["TWITTER"] = "TWITTER";
    SocialNetworkWrapperSocialNetworkEnum["FOURSQUARE"] = "FOURSQUARE";
    SocialNetworkWrapperSocialNetworkEnum["ANGELLIST"] = "ANGELLIST";
    SocialNetworkWrapperSocialNetworkEnum["INSTAGRAM"] = "INSTAGRAM";
    SocialNetworkWrapperSocialNetworkEnum["MYMAILRU"] = "MY_MAIL_RU";
    SocialNetworkWrapperSocialNetworkEnum["GPLUS"] = "GPLUS";
    SocialNetworkWrapperSocialNetworkEnum["GOOGLEPLUS"] = "GOOGLE_PLUS";
    SocialNetworkWrapperSocialNetworkEnum["SNAPCHAT"] = "SNAPCHAT";
    SocialNetworkWrapperSocialNetworkEnum["BADOO"] = "BADOO";
    SocialNetworkWrapperSocialNetworkEnum["FLING"] = "FLING";
    SocialNetworkWrapperSocialNetworkEnum["TPERSONA"] = "TPERSONA";
    SocialNetworkWrapperSocialNetworkEnum["PHNEWID"] = "PH_NEW_ID";
    SocialNetworkWrapperSocialNetworkEnum["BLACKHATWORLD"] = "BLACKHATWORLD";
    SocialNetworkWrapperSocialNetworkEnum["DUBSMASH"] = "DUBSMASH";
    SocialNetworkWrapperSocialNetworkEnum["GEORGIACITIZENSHIP"] = "GEORGIA_CITIZENSHIP";
    SocialNetworkWrapperSocialNetworkEnum["TELEGRAM"] = "TELEGRAM";
    SocialNetworkWrapperSocialNetworkEnum["WEBVSPRIMARY"] = "WEBVS_PRIMARY";
})(SocialNetworkWrapperSocialNetworkEnum = exports.SocialNetworkWrapperSocialNetworkEnum || (exports.SocialNetworkWrapperSocialNetworkEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SyncmeSourceEnum;
(function (SyncmeSourceEnum) {
    SyncmeSourceEnum["TC"] = "TC";
    SyncmeSourceEnum["ME"] = "ME";
    SyncmeSourceEnum["WHATSAPP"] = "WHATSAPP";
    SyncmeSourceEnum["SYNCME"] = "SYNCME";
    SyncmeSourceEnum["VIBER"] = "VIBER";
    SyncmeSourceEnum["LINE"] = "LINE";
    SyncmeSourceEnum["WECHAT"] = "WECHAT";
    SyncmeSourceEnum["IMO"] = "IMO";
    SyncmeSourceEnum["GETCONTACT"] = "GETCONTACT";
    SyncmeSourceEnum["TELEGRAM"] = "TELEGRAM";
    SyncmeSourceEnum["SKYPE"] = "SKYPE";
    SyncmeSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    SyncmeSourceEnum["EYECON"] = "EYECON";
    SyncmeSourceEnum["CALLAPP"] = "CALLAPP";
    SyncmeSourceEnum["TAMTAM"] = "TAMTAM";
    SyncmeSourceEnum["ZALO"] = "ZALO";
    SyncmeSourceEnum["DRUPE"] = "DRUPE";
    SyncmeSourceEnum["HIYA"] = "HIYA";
    SyncmeSourceEnum["DEEPWEB"] = "DEEPWEB";
})(SyncmeSourceEnum = exports.SyncmeSourceEnum || (exports.SyncmeSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TamtamGenderEnum;
(function (TamtamGenderEnum) {
    TamtamGenderEnum["UNKNOWN"] = "UNKNOWN";
    TamtamGenderEnum["MALE"] = "MALE";
    TamtamGenderEnum["FEMALE"] = "FEMALE";
})(TamtamGenderEnum = exports.TamtamGenderEnum || (exports.TamtamGenderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TamtamTypeEnum;
(function (TamtamTypeEnum) {
    TamtamTypeEnum["USERLIST"] = "USER_LIST";
    TamtamTypeEnum["EXTERNAL"] = "EXTERNAL";
})(TamtamTypeEnum = exports.TamtamTypeEnum || (exports.TamtamTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TamtamOptionsEnum;
(function (TamtamOptionsEnum) {
    TamtamOptionsEnum["TT"] = "TT";
    TamtamOptionsEnum["OFFICIAL"] = "OFFICIAL";
    TamtamOptionsEnum["PRIVATE"] = "PRIVATE";
    TamtamOptionsEnum["OK"] = "OK";
    TamtamOptionsEnum["CANUNBINDOK"] = "CAN_UNBIND_OK";
    TamtamOptionsEnum["BOT"] = "BOT";
    TamtamOptionsEnum["CONSTRUCTOR"] = "CONSTRUCTOR";
})(TamtamOptionsEnum = exports.TamtamOptionsEnum || (exports.TamtamOptionsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TamtamStatusEnum;
(function (TamtamStatusEnum) {
    TamtamStatusEnum["ACTIVE"] = "ACTIVE";
    TamtamStatusEnum["BLOCKED"] = "BLOCKED";
    TamtamStatusEnum["REMOVED"] = "REMOVED";
    TamtamStatusEnum["NOTFOUND"] = "NOT_FOUND";
})(TamtamStatusEnum = exports.TamtamStatusEnum || (exports.TamtamStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TamtamSourceEnum;
(function (TamtamSourceEnum) {
    TamtamSourceEnum["TC"] = "TC";
    TamtamSourceEnum["ME"] = "ME";
    TamtamSourceEnum["WHATSAPP"] = "WHATSAPP";
    TamtamSourceEnum["SYNCME"] = "SYNCME";
    TamtamSourceEnum["VIBER"] = "VIBER";
    TamtamSourceEnum["LINE"] = "LINE";
    TamtamSourceEnum["WECHAT"] = "WECHAT";
    TamtamSourceEnum["IMO"] = "IMO";
    TamtamSourceEnum["GETCONTACT"] = "GETCONTACT";
    TamtamSourceEnum["TELEGRAM"] = "TELEGRAM";
    TamtamSourceEnum["SKYPE"] = "SKYPE";
    TamtamSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    TamtamSourceEnum["EYECON"] = "EYECON";
    TamtamSourceEnum["CALLAPP"] = "CALLAPP";
    TamtamSourceEnum["TAMTAM"] = "TAMTAM";
    TamtamSourceEnum["ZALO"] = "ZALO";
    TamtamSourceEnum["DRUPE"] = "DRUPE";
    TamtamSourceEnum["HIYA"] = "HIYA";
    TamtamSourceEnum["DEEPWEB"] = "DEEPWEB";
})(TamtamSourceEnum = exports.TamtamSourceEnum || (exports.TamtamSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TcSourceEnum;
(function (TcSourceEnum) {
    TcSourceEnum["TC"] = "TC";
    TcSourceEnum["ME"] = "ME";
    TcSourceEnum["WHATSAPP"] = "WHATSAPP";
    TcSourceEnum["SYNCME"] = "SYNCME";
    TcSourceEnum["VIBER"] = "VIBER";
    TcSourceEnum["LINE"] = "LINE";
    TcSourceEnum["WECHAT"] = "WECHAT";
    TcSourceEnum["IMO"] = "IMO";
    TcSourceEnum["GETCONTACT"] = "GETCONTACT";
    TcSourceEnum["TELEGRAM"] = "TELEGRAM";
    TcSourceEnum["SKYPE"] = "SKYPE";
    TcSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    TcSourceEnum["EYECON"] = "EYECON";
    TcSourceEnum["CALLAPP"] = "CALLAPP";
    TcSourceEnum["TAMTAM"] = "TAMTAM";
    TcSourceEnum["ZALO"] = "ZALO";
    TcSourceEnum["DRUPE"] = "DRUPE";
    TcSourceEnum["HIYA"] = "HIYA";
    TcSourceEnum["DEEPWEB"] = "DEEPWEB";
})(TcSourceEnum = exports.TcSourceEnum || (exports.TcSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TelegramSourceEnum;
(function (TelegramSourceEnum) {
    TelegramSourceEnum["TC"] = "TC";
    TelegramSourceEnum["ME"] = "ME";
    TelegramSourceEnum["WHATSAPP"] = "WHATSAPP";
    TelegramSourceEnum["SYNCME"] = "SYNCME";
    TelegramSourceEnum["VIBER"] = "VIBER";
    TelegramSourceEnum["LINE"] = "LINE";
    TelegramSourceEnum["WECHAT"] = "WECHAT";
    TelegramSourceEnum["IMO"] = "IMO";
    TelegramSourceEnum["GETCONTACT"] = "GETCONTACT";
    TelegramSourceEnum["TELEGRAM"] = "TELEGRAM";
    TelegramSourceEnum["SKYPE"] = "SKYPE";
    TelegramSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    TelegramSourceEnum["EYECON"] = "EYECON";
    TelegramSourceEnum["CALLAPP"] = "CALLAPP";
    TelegramSourceEnum["TAMTAM"] = "TAMTAM";
    TelegramSourceEnum["ZALO"] = "ZALO";
    TelegramSourceEnum["DRUPE"] = "DRUPE";
    TelegramSourceEnum["HIYA"] = "HIYA";
    TelegramSourceEnum["DEEPWEB"] = "DEEPWEB";
})(TelegramSourceEnum = exports.TelegramSourceEnum || (exports.TelegramSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserDTORolesEnum;
(function (UserDTORolesEnum) {
    UserDTORolesEnum["ADMIN"] = "ADMIN";
    UserDTORolesEnum["USER"] = "USER";
})(UserDTORolesEnum = exports.UserDTORolesEnum || (exports.UserDTORolesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserInfoDTORolesEnum;
(function (UserInfoDTORolesEnum) {
    UserInfoDTORolesEnum["ADMIN"] = "ADMIN";
    UserInfoDTORolesEnum["USER"] = "USER";
})(UserInfoDTORolesEnum = exports.UserInfoDTORolesEnum || (exports.UserInfoDTORolesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserUpdateDTORolesEnum;
(function (UserUpdateDTORolesEnum) {
    UserUpdateDTORolesEnum["ADMIN"] = "ADMIN";
    UserUpdateDTORolesEnum["USER"] = "USER";
})(UserUpdateDTORolesEnum = exports.UserUpdateDTORolesEnum || (exports.UserUpdateDTORolesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ViberSourceEnum;
(function (ViberSourceEnum) {
    ViberSourceEnum["TC"] = "TC";
    ViberSourceEnum["ME"] = "ME";
    ViberSourceEnum["WHATSAPP"] = "WHATSAPP";
    ViberSourceEnum["SYNCME"] = "SYNCME";
    ViberSourceEnum["VIBER"] = "VIBER";
    ViberSourceEnum["LINE"] = "LINE";
    ViberSourceEnum["WECHAT"] = "WECHAT";
    ViberSourceEnum["IMO"] = "IMO";
    ViberSourceEnum["GETCONTACT"] = "GETCONTACT";
    ViberSourceEnum["TELEGRAM"] = "TELEGRAM";
    ViberSourceEnum["SKYPE"] = "SKYPE";
    ViberSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ViberSourceEnum["EYECON"] = "EYECON";
    ViberSourceEnum["CALLAPP"] = "CALLAPP";
    ViberSourceEnum["TAMTAM"] = "TAMTAM";
    ViberSourceEnum["ZALO"] = "ZALO";
    ViberSourceEnum["DRUPE"] = "DRUPE";
    ViberSourceEnum["HIYA"] = "HIYA";
    ViberSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ViberSourceEnum = exports.ViberSourceEnum || (exports.ViberSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var VkontakteSourceEnum;
(function (VkontakteSourceEnum) {
    VkontakteSourceEnum["TC"] = "TC";
    VkontakteSourceEnum["ME"] = "ME";
    VkontakteSourceEnum["WHATSAPP"] = "WHATSAPP";
    VkontakteSourceEnum["SYNCME"] = "SYNCME";
    VkontakteSourceEnum["VIBER"] = "VIBER";
    VkontakteSourceEnum["LINE"] = "LINE";
    VkontakteSourceEnum["WECHAT"] = "WECHAT";
    VkontakteSourceEnum["IMO"] = "IMO";
    VkontakteSourceEnum["GETCONTACT"] = "GETCONTACT";
    VkontakteSourceEnum["TELEGRAM"] = "TELEGRAM";
    VkontakteSourceEnum["SKYPE"] = "SKYPE";
    VkontakteSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    VkontakteSourceEnum["EYECON"] = "EYECON";
    VkontakteSourceEnum["CALLAPP"] = "CALLAPP";
    VkontakteSourceEnum["TAMTAM"] = "TAMTAM";
    VkontakteSourceEnum["ZALO"] = "ZALO";
    VkontakteSourceEnum["DRUPE"] = "DRUPE";
    VkontakteSourceEnum["HIYA"] = "HIYA";
    VkontakteSourceEnum["DEEPWEB"] = "DEEPWEB";
})(VkontakteSourceEnum = exports.VkontakteSourceEnum || (exports.VkontakteSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WechatSourceEnum;
(function (WechatSourceEnum) {
    WechatSourceEnum["TC"] = "TC";
    WechatSourceEnum["ME"] = "ME";
    WechatSourceEnum["WHATSAPP"] = "WHATSAPP";
    WechatSourceEnum["SYNCME"] = "SYNCME";
    WechatSourceEnum["VIBER"] = "VIBER";
    WechatSourceEnum["LINE"] = "LINE";
    WechatSourceEnum["WECHAT"] = "WECHAT";
    WechatSourceEnum["IMO"] = "IMO";
    WechatSourceEnum["GETCONTACT"] = "GETCONTACT";
    WechatSourceEnum["TELEGRAM"] = "TELEGRAM";
    WechatSourceEnum["SKYPE"] = "SKYPE";
    WechatSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    WechatSourceEnum["EYECON"] = "EYECON";
    WechatSourceEnum["CALLAPP"] = "CALLAPP";
    WechatSourceEnum["TAMTAM"] = "TAMTAM";
    WechatSourceEnum["ZALO"] = "ZALO";
    WechatSourceEnum["DRUPE"] = "DRUPE";
    WechatSourceEnum["HIYA"] = "HIYA";
    WechatSourceEnum["DEEPWEB"] = "DEEPWEB";
})(WechatSourceEnum = exports.WechatSourceEnum || (exports.WechatSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var WhatsappSourceEnum;
(function (WhatsappSourceEnum) {
    WhatsappSourceEnum["TC"] = "TC";
    WhatsappSourceEnum["ME"] = "ME";
    WhatsappSourceEnum["WHATSAPP"] = "WHATSAPP";
    WhatsappSourceEnum["SYNCME"] = "SYNCME";
    WhatsappSourceEnum["VIBER"] = "VIBER";
    WhatsappSourceEnum["LINE"] = "LINE";
    WhatsappSourceEnum["WECHAT"] = "WECHAT";
    WhatsappSourceEnum["IMO"] = "IMO";
    WhatsappSourceEnum["GETCONTACT"] = "GETCONTACT";
    WhatsappSourceEnum["TELEGRAM"] = "TELEGRAM";
    WhatsappSourceEnum["SKYPE"] = "SKYPE";
    WhatsappSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    WhatsappSourceEnum["EYECON"] = "EYECON";
    WhatsappSourceEnum["CALLAPP"] = "CALLAPP";
    WhatsappSourceEnum["TAMTAM"] = "TAMTAM";
    WhatsappSourceEnum["ZALO"] = "ZALO";
    WhatsappSourceEnum["DRUPE"] = "DRUPE";
    WhatsappSourceEnum["HIYA"] = "HIYA";
    WhatsappSourceEnum["DEEPWEB"] = "DEEPWEB";
})(WhatsappSourceEnum = exports.WhatsappSourceEnum || (exports.WhatsappSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ZaloSourceEnum;
(function (ZaloSourceEnum) {
    ZaloSourceEnum["TC"] = "TC";
    ZaloSourceEnum["ME"] = "ME";
    ZaloSourceEnum["WHATSAPP"] = "WHATSAPP";
    ZaloSourceEnum["SYNCME"] = "SYNCME";
    ZaloSourceEnum["VIBER"] = "VIBER";
    ZaloSourceEnum["LINE"] = "LINE";
    ZaloSourceEnum["WECHAT"] = "WECHAT";
    ZaloSourceEnum["IMO"] = "IMO";
    ZaloSourceEnum["GETCONTACT"] = "GETCONTACT";
    ZaloSourceEnum["TELEGRAM"] = "TELEGRAM";
    ZaloSourceEnum["SKYPE"] = "SKYPE";
    ZaloSourceEnum["VKONTAKTE"] = "VKONTAKTE";
    ZaloSourceEnum["EYECON"] = "EYECON";
    ZaloSourceEnum["CALLAPP"] = "CALLAPP";
    ZaloSourceEnum["TAMTAM"] = "TAMTAM";
    ZaloSourceEnum["ZALO"] = "ZALO";
    ZaloSourceEnum["DRUPE"] = "DRUPE";
    ZaloSourceEnum["HIYA"] = "HIYA";
    ZaloSourceEnum["DEEPWEB"] = "DEEPWEB";
})(ZaloSourceEnum = exports.ZaloSourceEnum || (exports.ZaloSourceEnum = {}));
/**
 * ApiToCheckHealthStatusOfAppApi - axios parameter creator
 * @export
 */
exports.ApiToCheckHealthStatusOfAppApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/health-checker/all";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {'ELASTICSEARCH' | 'IMAGESERVICE' | 'MONGODB' | 'DOCUMENTDB'} service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus: function (service, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'service' is not null or undefined
                            if (service === null || service === undefined) {
                                throw new base_1.RequiredError('service', 'Required parameter service was null or undefined when calling getServiceStatus.');
                            }
                            localVarPath = "/api/health-checker/{service}"
                                .replace("{" + "service" + "}", encodeURIComponent(String(service)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/health-checker";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ApiToCheckHealthStatusOfAppApi - functional programming interface
 * @export
 */
exports.ApiToCheckHealthStatusOfAppApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToCheckHealthStatusOfAppApiAxiosParamCreator(configuration).all(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {'ELASTICSEARCH' | 'IMAGESERVICE' | 'MONGODB' | 'DOCUMENTDB'} service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus: function (service, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToCheckHealthStatusOfAppApiAxiosParamCreator(configuration).getServiceStatus(service, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToCheckHealthStatusOfAppApiAxiosParamCreator(configuration).ping(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ApiToCheckHealthStatusOfAppApi - factory interface
 * @export
 */
exports.ApiToCheckHealthStatusOfAppApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        all: function (options) {
            return exports.ApiToCheckHealthStatusOfAppApiFp(configuration).all(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {'ELASTICSEARCH' | 'IMAGESERVICE' | 'MONGODB' | 'DOCUMENTDB'} service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatus: function (service, options) {
            return exports.ApiToCheckHealthStatusOfAppApiFp(configuration).getServiceStatus(service, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: function (options) {
            return exports.ApiToCheckHealthStatusOfAppApiFp(configuration).ping(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ApiToCheckHealthStatusOfAppApi - object-oriented interface
 * @export
 * @class ApiToCheckHealthStatusOfAppApi
 * @extends {BaseAPI}
 */
var ApiToCheckHealthStatusOfAppApi = /** @class */ (function (_super) {
    __extends(ApiToCheckHealthStatusOfAppApi, _super);
    function ApiToCheckHealthStatusOfAppApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToCheckHealthStatusOfAppApi
     */
    ApiToCheckHealthStatusOfAppApi.prototype.all = function (options) {
        var _this = this;
        return exports.ApiToCheckHealthStatusOfAppApiFp(this.configuration).all(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {'ELASTICSEARCH' | 'IMAGESERVICE' | 'MONGODB' | 'DOCUMENTDB'} service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToCheckHealthStatusOfAppApi
     */
    ApiToCheckHealthStatusOfAppApi.prototype.getServiceStatus = function (service, options) {
        var _this = this;
        return exports.ApiToCheckHealthStatusOfAppApiFp(this.configuration).getServiceStatus(service, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToCheckHealthStatusOfAppApi
     */
    ApiToCheckHealthStatusOfAppApi.prototype.ping = function (options) {
        var _this = this;
        return exports.ApiToCheckHealthStatusOfAppApiFp(this.configuration).ping(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiToCheckHealthStatusOfAppApi;
}(base_1.BaseAPI));
exports.ApiToCheckHealthStatusOfAppApi = ApiToCheckHealthStatusOfAppApi;
/**
 * ApiToGetAuditApi - axios parameter creator
 * @export
 */
exports.ApiToGetAuditApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} type
         * @param {AuditSearchFilter} auditSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAudits: function (type, auditSearchFilter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'type' is not null or undefined
                    if (type === null || type === undefined) {
                        throw new base_1.RequiredError('type', 'Required parameter type was null or undefined when calling exportAudits.');
                    }
                    // verify required parameter 'auditSearchFilter' is not null or undefined
                    if (auditSearchFilter === null || auditSearchFilter === undefined) {
                        throw new base_1.RequiredError('auditSearchFilter', 'Required parameter auditSearchFilter was null or undefined when calling exportAudits.');
                    }
                    localVarPath = "/api/audit/export/{type}"
                        .replace("{" + "type" + "}", encodeURIComponent(String(type)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof auditSearchFilter !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(auditSearchFilter !== undefined ? auditSearchFilter : {}) : (auditSearchFilter || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {AuditSearchFilter} auditSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAudits: function (auditSearchFilter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'auditSearchFilter' is not null or undefined
                    if (auditSearchFilter === null || auditSearchFilter === undefined) {
                        throw new base_1.RequiredError('auditSearchFilter', 'Required parameter auditSearchFilter was null or undefined when calling searchAudits.');
                    }
                    localVarPath = "/api/audit/search";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof auditSearchFilter !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(auditSearchFilter !== undefined ? auditSearchFilter : {}) : (auditSearchFilter || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ApiToGetAuditApi - functional programming interface
 * @export
 */
exports.ApiToGetAuditApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} type
         * @param {AuditSearchFilter} auditSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAudits: function (type, auditSearchFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToGetAuditApiAxiosParamCreator(configuration).exportAudits(type, auditSearchFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AuditSearchFilter} auditSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAudits: function (auditSearchFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToGetAuditApiAxiosParamCreator(configuration).searchAudits(auditSearchFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ApiToGetAuditApi - factory interface
 * @export
 */
exports.ApiToGetAuditApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} type
         * @param {AuditSearchFilter} auditSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAudits: function (type, auditSearchFilter, options) {
            return exports.ApiToGetAuditApiFp(configuration).exportAudits(type, auditSearchFilter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AuditSearchFilter} auditSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAudits: function (auditSearchFilter, options) {
            return exports.ApiToGetAuditApiFp(configuration).searchAudits(auditSearchFilter, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ApiToGetAuditApi - object-oriented interface
 * @export
 * @class ApiToGetAuditApi
 * @extends {BaseAPI}
 */
var ApiToGetAuditApi = /** @class */ (function (_super) {
    __extends(ApiToGetAuditApi, _super);
    function ApiToGetAuditApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} type
     * @param {AuditSearchFilter} auditSearchFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    ApiToGetAuditApi.prototype.exportAudits = function (type, auditSearchFilter, options) {
        var _this = this;
        return exports.ApiToGetAuditApiFp(this.configuration).exportAudits(type, auditSearchFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AuditSearchFilter} auditSearchFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetAuditApi
     */
    ApiToGetAuditApi.prototype.searchAudits = function (auditSearchFilter, options) {
        var _this = this;
        return exports.ApiToGetAuditApiFp(this.configuration).searchAudits(auditSearchFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiToGetAuditApi;
}(base_1.BaseAPI));
exports.ApiToGetAuditApi = ApiToGetAuditApi;
/**
 * ApiToGetImageFileApi - axios parameter creator
 * @export
 */
exports.ApiToGetImageFileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearStorage: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/image/clear-storage";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getImage.');
                    }
                    localVarPath = "/api/image/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ApiToGetImageFileApi - functional programming interface
 * @export
 */
exports.ApiToGetImageFileApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearStorage: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToGetImageFileApiAxiosParamCreator(configuration).clearStorage(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ApiToGetImageFileApiAxiosParamCreator(configuration).getImage(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ApiToGetImageFileApi - factory interface
 * @export
 */
exports.ApiToGetImageFileApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearStorage: function (options) {
            return exports.ApiToGetImageFileApiFp(configuration).clearStorage(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: function (id, options) {
            return exports.ApiToGetImageFileApiFp(configuration).getImage(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ApiToGetImageFileApi - object-oriented interface
 * @export
 * @class ApiToGetImageFileApi
 * @extends {BaseAPI}
 */
var ApiToGetImageFileApi = /** @class */ (function (_super) {
    __extends(ApiToGetImageFileApi, _super);
    function ApiToGetImageFileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetImageFileApi
     */
    ApiToGetImageFileApi.prototype.clearStorage = function (options) {
        var _this = this;
        return exports.ApiToGetImageFileApiFp(this.configuration).clearStorage(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiToGetImageFileApi
     */
    ApiToGetImageFileApi.prototype.getImage = function (id, options) {
        var _this = this;
        return exports.ApiToGetImageFileApiFp(this.configuration).getImage(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiToGetImageFileApi;
}(base_1.BaseAPI));
exports.ApiToGetImageFileApi = ApiToGetImageFileApi;
/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
exports.AuthControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {LoginDto} loginDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: function (loginDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'loginDto' is not null or undefined
                    if (loginDto === null || loginDto === undefined) {
                        throw new base_1.RequiredError('loginDto', 'Required parameter loginDto was null or undefined when calling authenticateUser.');
                    }
                    localVarPath = "/api/auth/login";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof loginDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(loginDto !== undefined ? loginDto : {}) : (loginDto || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (username, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    if (username === null || username === undefined) {
                        throw new base_1.RequiredError('username', 'Required parameter username was null or undefined when calling logout.');
                    }
                    localVarPath = "/api/auth/logout/{username}"
                        .replace("{" + "username" + "}", encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * AuthControllerApi - functional programming interface
 * @export
 */
exports.AuthControllerApiFp = function (configuration) {
    return {
        /**
         *
         * @param {LoginDto} loginDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: function (loginDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.AuthControllerApiAxiosParamCreator(configuration).authenticateUser(loginDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (username, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.AuthControllerApiAxiosParamCreator(configuration).logout(username, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AuthControllerApi - factory interface
 * @export
 */
exports.AuthControllerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {LoginDto} loginDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: function (loginDto, options) {
            return exports.AuthControllerApiFp(configuration).authenticateUser(loginDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: function (username, options) {
            return exports.AuthControllerApiFp(configuration).logout(username, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
var AuthControllerApi = /** @class */ (function (_super) {
    __extends(AuthControllerApi, _super);
    function AuthControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {LoginDto} loginDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    AuthControllerApi.prototype.authenticateUser = function (loginDto, options) {
        var _this = this;
        return exports.AuthControllerApiFp(this.configuration).authenticateUser(loginDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    AuthControllerApi.prototype.logout = function (username, options) {
        var _this = this;
        return exports.AuthControllerApiFp(this.configuration).logout(username, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthControllerApi;
}(base_1.BaseAPI));
exports.AuthControllerApi = AuthControllerApi;
/**
 * JobAPIApi - axios parameter creator
 * @export
 */
exports.JobAPIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreateJobDto} createJobDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob: function (createJobDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'createJobDto' is not null or undefined
                            if (createJobDto === null || createJobDto === undefined) {
                                throw new base_1.RequiredError('createJobDto', 'Required parameter createJobDto was null or undefined when calling createJob.');
                            }
                            localVarPath = "/api/job/range";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof createJobDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createJobDto !== undefined ? createJobDto : {}) : (createJobDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} name
         * @param {string} [country]
         * @param {string} [city]
         * @param {string} [provider]
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobWithFile: function (name, country, city, provider, inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'name' is not null or undefined
                            if (name === null || name === undefined) {
                                throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling createJobWithFile.');
                            }
                            localVarPath = "/api/job/file";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (country !== undefined) {
                                localVarQueryParameter['country'] = country;
                            }
                            if (city !== undefined) {
                                localVarQueryParameter['city'] = city;
                            }
                            if (provider !== undefined) {
                                localVarQueryParameter['provider'] = provider;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof inlineObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob: function (number, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'number' is not null or undefined
                            if (number === null || number === undefined) {
                                throw new base_1.RequiredError('number', 'Required parameter number was null or undefined when calling getJob.');
                            }
                            localVarPath = "/api/job/{number}"
                                .replace("{" + "number" + "}", encodeURIComponent(String(number)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} number
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobPhones: function (number, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'number' is not null or undefined
                            if (number === null || number === undefined) {
                                throw new base_1.RequiredError('number', 'Required parameter number was null or undefined when calling getJobPhones.');
                            }
                            localVarPath = "/api/job/{number}/phones"
                                .replace("{" + "number" + "}", encodeURIComponent(String(number)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: function (page, size, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/job";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainJob: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/job/main";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} number
         * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} jobStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobStatus: function (number, jobStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'number' is not null or undefined
                            if (number === null || number === undefined) {
                                throw new base_1.RequiredError('number', 'Required parameter number was null or undefined when calling updateJobStatus.');
                            }
                            // verify required parameter 'jobStatus' is not null or undefined
                            if (jobStatus === null || jobStatus === undefined) {
                                throw new base_1.RequiredError('jobStatus', 'Required parameter jobStatus was null or undefined when calling updateJobStatus.');
                            }
                            localVarPath = "/api/job/{number}/status/{jobStatus}"
                                .replace("{" + "number" + "}", encodeURIComponent(String(number)))
                                .replace("{" + "jobStatus" + "}", encodeURIComponent(String(jobStatus)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobAPIApi - functional programming interface
 * @export
 */
exports.JobAPIApiFp = function (configuration) {
    return {
        /**
         *
         * @param {CreateJobDto} createJobDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob: function (createJobDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).createJob(createJobDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} name
         * @param {string} [country]
         * @param {string} [city]
         * @param {string} [provider]
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobWithFile: function (name, country, city, provider, inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).createJobWithFile(name, country, city, provider, inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob: function (number, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).getJob(number, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} number
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobPhones: function (number, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).getJobPhones(number, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: function (page, size, status, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).getJobs(page, size, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainJob: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).getMainJob(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} number
         * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} jobStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobStatus: function (number, jobStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.JobAPIApiAxiosParamCreator(configuration).updateJobStatus(number, jobStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * JobAPIApi - factory interface
 * @export
 */
exports.JobAPIApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {CreateJobDto} createJobDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJob: function (createJobDto, options) {
            return exports.JobAPIApiFp(configuration).createJob(createJobDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} name
         * @param {string} [country]
         * @param {string} [city]
         * @param {string} [provider]
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobWithFile: function (name, country, city, provider, inlineObject, options) {
            return exports.JobAPIApiFp(configuration).createJobWithFile(name, country, city, provider, inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJob: function (number, options) {
            return exports.JobAPIApiFp(configuration).getJob(number, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} number
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobPhones: function (number, page, size, options) {
            return exports.JobAPIApiFp(configuration).getJobPhones(number, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [size]
         * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobs: function (page, size, status, options) {
            return exports.JobAPIApiFp(configuration).getJobs(page, size, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMainJob: function (options) {
            return exports.JobAPIApiFp(configuration).getMainJob(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} number
         * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} jobStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobStatus: function (number, jobStatus, options) {
            return exports.JobAPIApiFp(configuration).updateJobStatus(number, jobStatus, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * JobAPIApi - object-oriented interface
 * @export
 * @class JobAPIApi
 * @extends {BaseAPI}
 */
var JobAPIApi = /** @class */ (function (_super) {
    __extends(JobAPIApi, _super);
    function JobAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateJobDto} createJobDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.createJob = function (createJobDto, options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).createJob(createJobDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} name
     * @param {string} [country]
     * @param {string} [city]
     * @param {string} [provider]
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.createJobWithFile = function (name, country, city, provider, inlineObject, options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).createJobWithFile(name, country, city, provider, inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.getJob = function (number, options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).getJob(number, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} number
     * @param {number} [page]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.getJobPhones = function (number, page, size, options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).getJobPhones(number, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [size]
     * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.getJobs = function (page, size, status, options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).getJobs(page, size, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.getMainJob = function (options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).getMainJob(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} number
     * @param {'IN_PROGRESS' | 'PAUSED' | 'SCHEDULED' | 'DONE' | 'CANCELED'} jobStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAPIApi
     */
    JobAPIApi.prototype.updateJobStatus = function (number, jobStatus, options) {
        var _this = this;
        return exports.JobAPIApiFp(this.configuration).updateJobStatus(number, jobStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return JobAPIApi;
}(base_1.BaseAPI));
exports.JobAPIApi = JobAPIApi;
/**
 * ProfileAPIApi - axios parameter creator
 * @export
 */
exports.ProfileAPIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (phone, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'phone' is not null or undefined
                            if (phone === null || phone === undefined) {
                                throw new base_1.RequiredError('phone', 'Required parameter phone was null or undefined when calling deleteProfile.');
                            }
                            localVarPath = "/api/profile/delete/{phone}"
                                .replace("{" + "phone" + "}", encodeURIComponent(String(phone)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfile: function (phone, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'phone' is not null or undefined
                            if (phone === null || phone === undefined) {
                                throw new base_1.RequiredError('phone', 'Required parameter phone was null or undefined when calling exportProfile.');
                            }
                            localVarPath = "/api/profile/individual-export";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            if (phone !== undefined) {
                                localVarQueryParameter['phone'] = phone;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [phone]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfiles: function (phone, email, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/profile/individual-export-as-is";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            if (phone !== undefined) {
                                localVarQueryParameter['phone'] = phone;
                            }
                            if (email !== undefined) {
                                localVarQueryParameter['email'] = email;
                            }
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfiles1: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestBody' is not null or undefined
                            if (requestBody === null || requestBody === undefined) {
                                throw new base_1.RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling exportProfiles1.');
                            }
                            localVarPath = "/api/profile/export";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileByPhone: function (phone, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'phone' is not null or undefined
                            if (phone === null || phone === undefined) {
                                throw new base_1.RequiredError('phone', 'Required parameter phone was null or undefined when calling getProfileByPhone.');
                            }
                            localVarPath = "/api/profile/{phone}"
                                .replace("{" + "phone" + "}", encodeURIComponent(String(phone)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} type
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilesByPhone: function (type, requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'type' is not null or undefined
                            if (type === null || type === undefined) {
                                throw new base_1.RequiredError('type', 'Required parameter type was null or undefined when calling getProfilesByPhone.');
                            }
                            // verify required parameter 'requestBody' is not null or undefined
                            if (requestBody === null || requestBody === undefined) {
                                throw new base_1.RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling getProfilesByPhone.');
                            }
                            localVarPath = "/api/profile/search/by-phones/{type}"
                                .replace("{" + "type" + "}", encodeURIComponent(String(type)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ImportProfileDto} importProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProfile: function (importProfileDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'importProfileDto' is not null or undefined
                            if (importProfileDto === null || importProfileDto === undefined) {
                                throw new base_1.RequiredError('importProfileDto', 'Required parameter importProfileDto was null or undefined when calling importProfile.');
                            }
                            localVarPath = "/api/profile/import";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof importProfileDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(importProfileDto !== undefined ? importProfileDto : {}) : (importProfileDto || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageIdProfiles: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestBody' is not null or undefined
                            if (requestBody === null || requestBody === undefined) {
                                throw new base_1.RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling searchByImageIdProfiles.');
                            }
                            localVarPath = "/api/profile/search/by-imageIds";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageProfiles: function (inlineObject1, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/profile/image/search";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof inlineObject1 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {}) : (inlineObject1 || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageProfiles1: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'body' is not null or undefined
                            if (body === null || body === undefined) {
                                throw new base_1.RequiredError('body', 'Required parameter body was null or undefined when calling searchByImageProfiles1.');
                            }
                            localVarPath = "/api/profile/image/external-search";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ProfileSearchFilter} profileSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles: function (profileSearchFilter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'profileSearchFilter' is not null or undefined
                            if (profileSearchFilter === null || profileSearchFilter === undefined) {
                                throw new base_1.RequiredError('profileSearchFilter', 'Required parameter profileSearchFilter was null or undefined when calling searchProfiles.');
                            }
                            localVarPath = "/api/profile/search";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof profileSearchFilter !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(profileSearchFilter !== undefined ? profileSearchFilter : {}) : (profileSearchFilter || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProfileAPIApi - functional programming interface
 * @export
 */
exports.ProfileAPIApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (phone, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).deleteProfile(phone, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfile: function (phone, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).exportProfile(phone, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [phone]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfiles: function (phone, email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).exportProfiles(phone, email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfiles1: function (requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).exportProfiles1(requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileByPhone: function (phone, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).getProfileByPhone(phone, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} type
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilesByPhone: function (type, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).getProfilesByPhone(type, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ImportProfileDto} importProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProfile: function (importProfileDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).importProfile(importProfileDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageIdProfiles: function (requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).searchByImageIdProfiles(requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageProfiles: function (inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).searchByImageProfiles(inlineObject1, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageProfiles1: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).searchByImageProfiles1(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ProfileSearchFilter} profileSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles: function (profileSearchFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.ProfileAPIApiAxiosParamCreator(configuration).searchProfiles(profileSearchFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProfileAPIApi - factory interface
 * @export
 */
exports.ProfileAPIApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: function (phone, options) {
            return exports.ProfileAPIApiFp(configuration).deleteProfile(phone, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfile: function (phone, options) {
            return exports.ProfileAPIApiFp(configuration).exportProfile(phone, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [phone]
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfiles: function (phone, email, options) {
            return exports.ProfileAPIApiFp(configuration).exportProfiles(phone, email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProfiles1: function (requestBody, options) {
            return exports.ProfileAPIApiFp(configuration).exportProfiles1(requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileByPhone: function (phone, options) {
            return exports.ProfileAPIApiFp(configuration).getProfileByPhone(phone, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} type
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilesByPhone: function (type, requestBody, options) {
            return exports.ProfileAPIApiFp(configuration).getProfilesByPhone(type, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ImportProfileDto} importProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProfile: function (importProfileDto, options) {
            return exports.ProfileAPIApiFp(configuration).importProfile(importProfileDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageIdProfiles: function (requestBody, options) {
            return exports.ProfileAPIApiFp(configuration).searchByImageIdProfiles(requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageProfiles: function (inlineObject1, options) {
            return exports.ProfileAPIApiFp(configuration).searchByImageProfiles(inlineObject1, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByImageProfiles1: function (body, options) {
            return exports.ProfileAPIApiFp(configuration).searchByImageProfiles1(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ProfileSearchFilter} profileSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfiles: function (profileSearchFilter, options) {
            return exports.ProfileAPIApiFp(configuration).searchProfiles(profileSearchFilter, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ProfileAPIApi - object-oriented interface
 * @export
 * @class ProfileAPIApi
 * @extends {BaseAPI}
 */
var ProfileAPIApi = /** @class */ (function (_super) {
    __extends(ProfileAPIApi, _super);
    function ProfileAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.deleteProfile = function (phone, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).deleteProfile(phone, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.exportProfile = function (phone, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).exportProfile(phone, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [phone]
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.exportProfiles = function (phone, email, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).exportProfiles(phone, email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.exportProfiles1 = function (requestBody, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).exportProfiles1(requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.getProfileByPhone = function (phone, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).getProfileByPhone(phone, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} type
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.getProfilesByPhone = function (type, requestBody, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).getProfilesByPhone(type, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ImportProfileDto} importProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.importProfile = function (importProfileDto, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).importProfile(importProfileDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.searchByImageIdProfiles = function (requestBody, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).searchByImageIdProfiles(requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.searchByImageProfiles = function (inlineObject1, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).searchByImageProfiles(inlineObject1, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.searchByImageProfiles1 = function (body, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).searchByImageProfiles1(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ProfileSearchFilter} profileSearchFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileAPIApi
     */
    ProfileAPIApi.prototype.searchProfiles = function (profileSearchFilter, options) {
        var _this = this;
        return exports.ProfileAPIApiFp(this.configuration).searchProfiles(profileSearchFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProfileAPIApi;
}(base_1.BaseAPI));
exports.ProfileAPIApi = ProfileAPIApi;
/**
 * Search4facesAPIApi - axios parameter creator
 * @export
 */
exports.Search4facesAPIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {{ [key: string]: object; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFaces: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'requestBody' is not null or undefined
                            if (requestBody === null || requestBody === undefined) {
                                throw new base_1.RequiredError('requestBody', 'Required parameter requestBody was null or undefined when calling detectFaces.');
                            }
                            localVarPath = "/api/search4faces";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * Search4facesAPIApi - functional programming interface
 * @export
 */
exports.Search4facesAPIApiFp = function (configuration) {
    return {
        /**
         *
         * @param {{ [key: string]: object; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFaces: function (requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.Search4facesAPIApiAxiosParamCreator(configuration).detectFaces(requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * Search4facesAPIApi - factory interface
 * @export
 */
exports.Search4facesAPIApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {{ [key: string]: object; }} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFaces: function (requestBody, options) {
            return exports.Search4facesAPIApiFp(configuration).detectFaces(requestBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * Search4facesAPIApi - object-oriented interface
 * @export
 * @class Search4facesAPIApi
 * @extends {BaseAPI}
 */
var Search4facesAPIApi = /** @class */ (function (_super) {
    __extends(Search4facesAPIApi, _super);
    function Search4facesAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {{ [key: string]: object; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Search4facesAPIApi
     */
    Search4facesAPIApi.prototype.detectFaces = function (requestBody, options) {
        var _this = this;
        return exports.Search4facesAPIApiFp(this.configuration).detectFaces(requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return Search4facesAPIApi;
}(base_1.BaseAPI));
exports.Search4facesAPIApi = Search4facesAPIApi;
/**
 * StatAPIApi - axios parameter creator
 * @export
 */
exports.StatAPIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryStat: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localVarPath = "/api/stat/country-phone";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * StatAPIApi - functional programming interface
 * @export
 */
exports.StatAPIApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryStat: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatAPIApiAxiosParamCreator(configuration).getCountryStat(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * StatAPIApi - factory interface
 * @export
 */
exports.StatAPIApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryStat: function (options) {
            return exports.StatAPIApiFp(configuration).getCountryStat(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * StatAPIApi - object-oriented interface
 * @export
 * @class StatAPIApi
 * @extends {BaseAPI}
 */
var StatAPIApi = /** @class */ (function (_super) {
    __extends(StatAPIApi, _super);
    function StatAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatAPIApi
     */
    StatAPIApi.prototype.getCountryStat = function (options) {
        var _this = this;
        return exports.StatAPIApiFp(this.configuration).getCountryStat(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StatAPIApi;
}(base_1.BaseAPI));
exports.StatAPIApi = StatAPIApi;
/**
 * UserAPIApi - axios parameter creator
 * @export
 */
exports.UserAPIApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteUser.');
                            }
                            localVarPath = "/api/user/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserSearchFilter} userSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (userSearchFilter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userSearchFilter' is not null or undefined
                            if (userSearchFilter === null || userSearchFilter === undefined) {
                                throw new base_1.RequiredError('userSearchFilter', 'Required parameter userSearchFilter was null or undefined when calling getUsers.');
                            }
                            localVarPath = "/api/user/search";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof userSearchFilter !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(userSearchFilter !== undefined ? userSearchFilter : {}) : (userSearchFilter || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserDTO} userDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser: function (userDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'userDTO' is not null or undefined
                            if (userDTO === null || userDTO === undefined) {
                                throw new base_1.RequiredError('userDTO', 'Required parameter userDTO was null or undefined when calling registerUser.');
                            }
                            localVarPath = "/api/user";
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof userDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(userDTO !== undefined ? userDTO : {}) : (userDTO || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {UserUpdateDTO} userUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, userUpdateDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, accessToken, _a, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            if (id === null || id === undefined) {
                                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling updateUser.');
                            }
                            // verify required parameter 'userUpdateDTO' is not null or undefined
                            if (userUpdateDTO === null || userUpdateDTO === undefined) {
                                throw new base_1.RequiredError('userUpdateDTO', 'Required parameter userUpdateDTO was null or undefined when calling updateUser.');
                            }
                            localVarPath = "/api/user/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, 'https://example.com');
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            if (!(configuration && configuration.accessToken)) return [3 /*break*/, 5];
                            if (!(typeof configuration.accessToken === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, configuration.accessToken()];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, configuration.accessToken];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            accessToken = _a;
                            localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
                            _b.label = 5;
                        case 5:
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            query = new URLSearchParams(localVarUrlObj.search);
                            for (key in localVarQueryParameter) {
                                query.set(key, localVarQueryParameter[key]);
                            }
                            for (key in options.query) {
                                query.set(key, options.query[key]);
                            }
                            localVarUrlObj.search = (new URLSearchParams(query)).toString();
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            needsSerialization = (typeof userUpdateDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                            localVarRequestOptions.data = needsSerialization ? JSON.stringify(userUpdateDTO !== undefined ? userUpdateDTO : {}) : (userUpdateDTO || "");
                            return [2 /*return*/, {
                                    url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * UserAPIApi - functional programming interface
 * @export
 */
exports.UserAPIApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.UserAPIApiAxiosParamCreator(configuration).deleteUser(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserSearchFilter} userSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (userSearchFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.UserAPIApiAxiosParamCreator(configuration).getUsers(userSearchFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserDTO} userDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser: function (userDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.UserAPIApiAxiosParamCreator(configuration).registerUser(userDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {UserUpdateDTO} userUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, userUpdateDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.UserAPIApiAxiosParamCreator(configuration).updateUser(id, userUpdateDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * UserAPIApi - factory interface
 * @export
 */
exports.UserAPIApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            return exports.UserAPIApiFp(configuration).deleteUser(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UserSearchFilter} userSearchFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (userSearchFilter, options) {
            return exports.UserAPIApiFp(configuration).getUsers(userSearchFilter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UserDTO} userDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUser: function (userDTO, options) {
            return exports.UserAPIApiFp(configuration).registerUser(userDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {UserUpdateDTO} userUpdateDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, userUpdateDTO, options) {
            return exports.UserAPIApiFp(configuration).updateUser(id, userUpdateDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * UserAPIApi - object-oriented interface
 * @export
 * @class UserAPIApi
 * @extends {BaseAPI}
 */
var UserAPIApi = /** @class */ (function (_super) {
    __extends(UserAPIApi, _super);
    function UserAPIApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    UserAPIApi.prototype.deleteUser = function (id, options) {
        var _this = this;
        return exports.UserAPIApiFp(this.configuration).deleteUser(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UserSearchFilter} userSearchFilter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    UserAPIApi.prototype.getUsers = function (userSearchFilter, options) {
        var _this = this;
        return exports.UserAPIApiFp(this.configuration).getUsers(userSearchFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UserDTO} userDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    UserAPIApi.prototype.registerUser = function (userDTO, options) {
        var _this = this;
        return exports.UserAPIApiFp(this.configuration).registerUser(userDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {UserUpdateDTO} userUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAPIApi
     */
    UserAPIApi.prototype.updateUser = function (id, userUpdateDTO, options) {
        var _this = this;
        return exports.UserAPIApiFp(this.configuration).updateUser(id, userUpdateDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserAPIApi;
}(base_1.BaseAPI));
exports.UserAPIApi = UserAPIApi;
